import useStore from "../../../store"
import { useEffect } from "react"
import { Tabs } from "@chakra-ui/react"
import UnitInfo from "./UnitInfo"
import MakePayment from "../MakePayment/MakePayment"
import Spinner from "../../common/Spinner"
import PendingNAP from "./PendingNAP"
import UnitWarning from "./UnitWarning"
import PendingNsfWarning from "./PendingNsfWarning"
import Breadcrumbs from "../../common/Breadcrumbs"
import { useIsMobile } from "../../../hooks/useIsMobile"
import TransferPageBody from "../TransferPage/TransferPageBody"
import TransferHeader from "../TransferPage/TransferHeader"
import UnitNotes from "./UnitNotes"
import UnitWarningContainer from "./UnitWarningContainer"
import { colors } from "../../../utilities/colors"
import UnitFiles from "./UnitFiles"
import AppliedCouponsBanner from "./AppliedCouponsBanner"

export default function EmployeeUnitPageBody({ unitId }) {
  const unit = useStore((state) => state.unit)
  const fetchUnit = useStore((state) => state.fetchUnit)
  const isMobile = useIsMobile()

  useEffect(() => {
    fetchUnit(unitId)
  }, [unitId])

  const TABS = { unit_info: "Unit Info", notes: "Notes", files: "Files" }

  return (
    <>
      {isMobile && <Breadcrumbs />}
      {unit && unit.id == unitId ? (
        <div className="flex flex-col items-start w-full mt-3">
          <div className="font-bold ml-2 mb-4">
            <p className="text-lg text-grey-300">
              {unit.attributes.year} {unit.attributes.make}
            </p>
            <p className="text-4xl text-grey-100">{unit.attributes.model}</p>
            <div className="flex items-center">
              {unit.attributes["dealer-name"]}
            </div>
          </div>
          <div className="flex flex-col items-center w-full">
            <AppliedCouponsBanner appliedCoupons={unit.attributes["applied-coupons"]} />
            {unit.attributes.transportation &&
              <UnitWarningContainer colorStyles="text-yellow border-yellow">
                <span>Transportation Unit</span>
              </UnitWarningContainer>
            }
            <PendingNsfWarning unit={unit} />
            <UnitWarning unit={unit} />
            {unit.attributes.status === "Pending" && <PendingNAP />}
          </div>
          <Tabs.Root
            variant="soft-rounded"
            defaultValue="unit_info"
            lazyMount
            unmountOnExit
            className="w-full"
          >
            <Tabs.List
              className="w-full flex flex-wrap justify-start bg-grey-900"
              position="sticky"
              top="0"
              zIndex={isMobile ? 100 : 1000}
              pt={isMobile ? 1 : 3}
            >
              {Object.keys(TABS).map((tab) => (
                <Tabs.Trigger
                  key={tab}
                  data-testid={`${tab}-tab`}
                  value={tab}
                  _selected={{ color: colors.green, bg: colors.grey900 }}
                  color={colors.grey100}
                  mx={3}
                >
                  {TABS[tab]}
                </Tabs.Trigger>
              ))}
            </Tabs.List>
            <Tabs.Content p={0} value="unit_info">
              <UnitInfo />
              {unit.attributes["ach-initiated"] ? (
                <div className="w-full border-t-2 border-grey-700 bg-grey-900">
                  <TransferHeader />
                  <TransferPageBody
                    transferId={unit.attributes["pending-transfer-id"]}
                    showAltData={false}
                  />
                </div>
              ) : (
                <MakePayment />
              )}
            </Tabs.Content>
            <Tabs.Content p={0} value="notes">
              <UnitNotes unitId={unitId} />
            </Tabs.Content>
            <Tabs.Content p={0} value="files">
              <UnitFiles unitId={unitId} />
            </Tabs.Content>
          </Tabs.Root>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full">
          <Spinner />
        </div>
      )}
    </>
  )
}
